export default __webpack_public_path__ + "static/media/2018 GENERAL INFORMATION SHEET (GIS).4414403f.pdf";